import {
    GET_ALL_AGENCY,
    GET_SINGLE_AGENCY,
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
} from './agencyTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_AGENCY:
            return {
                ...state,
                all_agency: action.payload,
            }
        case GET_SINGLE_AGENCY:
            return {
                ...state,
                single_agency: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
